import PersonalDetails from './PersonalDetails';

export default PersonalDetails;
